module.exports = {
  lang: {
    t1: `Home`,
    t2: `Cartolina`,
    t3: `Seguire`,
    t4: `Contatti`,
    t5: `Messaggi`,
    t6: `Accedi`,
    t7: `Registrare`,
    t8: `Nuova piattaforma di connettività commerciale globale, nuovo terreno per il marketing digitale delle imprese`,
    t9: `WeMeet - Accesso con Numero di Telefono`,
    t10: `Numero di Telefono`,
    t11: `Codice di verifica`,
    t12: `Si prega di inserire il numero di telefono`,
    t13: `Si prega di inserire il codice di verifica`,
    t14: `Ottenere`,
    t15: `Accesso`,
    t16: `Si prega di inserire il numero di telefono mobile nel formato corretto`,
    t17: `Codice di verifica inviato`,
    t18: `Codice di verifica inserito errato. Si prega di verificare e reinserire.`,
    t19: `Accesso riuscito`,
    t20: `Il tuo codice di verifica è (0). Utilizzalo entro {1} minuto/i.`,
    t21: `Annulla`,
    t22: `Confermare`,
    t23: `Suggerimenti utili`,
    t24: `La registrazione del tuo account WeMeet non è ancora stata completata. Agisci ora per concludere il processo di registrazione e godere di interazioni variegate e possibilità infinite.`,
    t25: `Vai alla registrazione`,
    t26: `Accesso all'account WeMeet tramite e-mail`,
    t27: `Nome dell'account`,
    t28: `Inserisci il tuo indirizzo email`,
    t29: `Password`,
    t30: `Inserisci la tua password`,
    t31: `Hai dimenticato la password?`,
    t32: `Accedi`,
    t33: `Altre modalità di accesso`,
    t34: `Già registrato per il Mini Programma WeMeet? Utilizzalo ora.`,
    t35: `Accedi con il numero di telefono`,
    t36: `Per favore inserisci prima la tua email.`,
    t37: `Per favore inserisci prima la tua password.`,
    t38: `Il formato dell'e-mail è errato`,
    t39: `Se hai già un account WeMeet, puoi accedere direttamente`,
    t40: `Accedi`,
    t41: `Immagine del profilo`,
    t42: `Carica una foto del profilo vera`,
    t43: `Nome completo`,
    t44: `Nome`,
    t45: `Cognome`,
    t46: `Nome dell'organizzazione`,
    t47: `Si prega di inserire il nome della vostra organizzazione`,
    t48: `Posizione`,
    t49: `Si prega di inserire il titolo del vostro incarico all'interno dell'organizzazione`,
    t50: `E-mail`,
    t51: `Inserisci il tuo indirizzo email`,
    t52: `Numero di Telefono`,
    t53: `Si prega di inserire il numero di telefono`,
    t54: `Regione`,
    t55: `Si prega di selezionare una regione`,
    t56: `Zona`,
    t57: `Si prega di selezionare provincia, città e quartiere`,
    t58: `Indirizzo`,
    t59: `Si prega di inserire il vostro indirizzo`,
    t60: `Ho letto e accetto i`,
    t61: `Termini di Servizio`,
    t62: `Informativa sulla privacy`,
    t63: `Continua`,
    t64: `Si prega di selezionare prima l'accordo utente`,
    t65: `Si prega di inserire il tuo nome`,
    t66: `Compila il tuo cognome`,
    t67: `Compila prima la tua e-mail`,
    t68: `Compila prima il nome della tua organizzazione`,
    t69: `Il formato dell'e-mail è errato`,
    t70: `Annulla`,
    t71: `Completa`,
    t72: `Verifica numero mobile`,
    t73: `Numero di Telefono`,
    t74: `Codice di verifica`,
    t75: `Si prega di inserire il codice di verifica`,
    t76: `Ottenere`,
    t77: `Salta verifica`,
    t78: `Invia`,
    t79: `Verificato`,
    t80: `Codice di verifica inserito errato. Si prega di verificare e reinserire.`,
    t81: `Saltato`,
    t82: `Suggerimenti utili`,
    t83: `Il numero di telefono che hai inserito è già registrato con un account WeMeet. Non è necessario registrarsi di nuovo, effettua l'accesso ora.`,
    t84: `Vai alla pagina di accesso`,
    t85: `Suggerimenti utili`,
    t86: `L'indirizzo email che hai inserito è già registrato con un account WeMeet. Non è necessario registrarsi di nuovo, effettua l'accesso ora.`,
    t87: `Vai alla pagina di accesso`,
    t88: `È stato inviato un link di verifica.`,
    t89: `Controlla la tua casella di posta elettronica e fai clic sul link per completare la registrazione.`,
    t90: `Capito`,
    t91: `Benvenuto su WeMeet`,
    t92: `Benvenuto su WeMeet! Clicca sul pulsante per completare la tua registrazione. Promemoria gentile: questo link è valido per 24 ore, si prega di agire con celerità.`,
    t93: `Registrazione completata`,
    t94: `La tua email è stata attivata. Inserisci la tua password.`,
    t95: `Inserisci la password`,
    t96: `Inserisci la tua password`,
    t97: `Conferma la password`,
    t98: `Per favore reinserisci la tua password`,
    t99: `Deve contenere una combinazione di lettere maiuscole e minuscole, numeri e caratteri speciali, con una lunghezza compresa tra 8 e 20 caratteri`,
    t100: `Inserisci la tua password`,
    t101: `Per favore reinserisci la tua password`,
    t102: `Le password non corrispondono`,
    t103: `Congratulazioni per aver completato la registrazione`,
    t104: `Ti sei loggato in WeMeet. Ora puoi continuare le tue azioni precedenti.`,
    t105: `Continua la tua esperienza`,
    t106: `Suggerimenti utili`,
    t107: `Il link è scaduto. Per favore, clicca sul pulsante per riprenderlo.`,
    t108: `Inviare di nuovo`,
    t109: `Condizioni del servizio`,
    t110: `Informativa sulla privacy`,
    t111: `Recupera la password`,
    t112: `Per favore inserisci l'account per cui desideri recuperare la password`,
    t113: `Nome dell'account`,
    t114: `Inserisci il tuo indirizzo email`,
    t115: `Invia`,
    t116: `Per favore inserisci prima la tua email.`,
    t117: `Il formato dell'e-mail è errato`,
    t118: `Email inviato`,
    t119: `Controlla la tua casella di posta elettronica, clicca sul link e reimposta la tua password.`,
    t120: `Capito`,
    t121: `Reimpostazione password - WeMeet`,
    t122: `La tua richiesta di reimpostazione della password è stata confermata e il sistema ha generato un link temporaneo per la reimpostazione della password. Promemoria gentile: questo link è valido per 24 ore, si prega di agire con celerità.`,
    t123: `Reimposta password`,
    t124: `Reimpostazione password riuscita`,
    t125: `Sei stato autenticato su WeMeet. Bentornato.`,
    t126: `Vai alla home page`,
    t127: `Contatti`,
    t128: `Nuova richiesta di contatto`,
    t129: `Accetto`,
    t130: `Ignorare`,
    t131: `Approvato`,
    t132: `Ignorato`,
    t133: `Seguente`,
    t134: `Seguito`,
    t135: `Messaggi`,
    t136: `Richiesta in sospeso`,
    t137: `Inserisci il tuo nome o il tuo numero di telefono`,
    t138: `Nessun contenuto corrispondente trovato`,
    t139: `Non ci sono altri elementi disponibili`,
    t140: `Richiesta di contatto`,
    t141: `Accetto`,
    t142: `Ignorare`,
    t143: `Approvato`,
    t144: `Ignorato`,
    t145: `Spazio WeMeet AI`,
    t146: `Seguendo`,
    t147: `Non seguire più`,
    t148: `vCard`,
    t149: `Collegare`,
    t150: `Inviare un messaggio`,
    t151: `In attesa di approvazione`,
    t152: `Rimuovi contatto`,
    t153: `Presentazione personale`,
    t154: `Profilo personale`,
    t155: `Suggerimenti utili`,
    t156: `La tua richiesta di contatto è stata inviata. Al momento dell'approvazione, ti seguirà automaticamente. Puoi anche scegliere di seguire questo utente subito per saperne di più su di lui.`,
    t157: `Non seguire per ora`,
    t158: `Seguire`,
    t159: `Seguendo`,
    t160: `Rimuovi relazione contatto`,
    t161: `Dopo aver rimosso la relazione di contatto, l'altra persona non sarà più in grado di visualizzare le tue informazioni personali, ma non ti sottoscriverà automaticamente.`,
    t162: `Ripensaci`,
    t163: `Rimuovi contatto`,
    t164: `Operazione completata con successo`,
    t165: `Assistente AI WeMeet`,
    t166: `Inserire la vostra domanda`,
    t167: `Invia`,
    t168: `Si prega di notare che il contenuto dell'interazione con l'IA potrebbe essere impreciso e non rappresentare il punto di vista della piattaforma.`,
    t169: `Biglietto da visita WeMeet`,
    t170: `Scarica`,
    t171: `Modifica biglietto da visita`,
    t172: `Scarica codice QR`,
    t173: `L'immagine è stata generata. Per favore salvala. Scansiona il codice QR per salvare il contatto.`,
    t174: `Immagine del profilo`,
    t175: `Carica una foto del profilo vera`,
    t176: `Nome completo`,
    t177: `Nome`,
    t178: `Cognome`,
    t179: `Inserisci il tuo nome`,
    t180: `Nome dell'organizzazione`,
    t181: `Si prega di inserire il nome della vostra organizzazione`,
    t182: `Posizione`,
    t183: `Si prega di inserire il titolo del vostro incarico all'interno dell'organizzazione`,
    t184: `E-mail`,
    t185: `Inserisci il tuo indirizzo email`,
    t186: `Numero di Telefono`,
    t187: `Si prega di inserire il numero di telefono`,
    t188: `Regione`,
    t189: `Si prega di selezionare una regione`,
    t190: `Zona`,
    t191: `Si prega di selezionare provincia, città e quartiere`,
    t192: `Indirizzo`,
    t193: `Si prega di inserire il vostro indirizzo`,
    t194: `Si prega di inserire il tuo nome`,
    t195: `Compila il tuo cognome`,
    t196: `Compila prima la tua e-mail`,
    t197: `Compila prima il nome della tua organizzazione`,
    t198: `Il formato dell'e-mail è errato`,
    t199: `Stanza di chat`,
    t200: `Galleria fotografica`,
    t201: `Scatta una foto`,
    t202: `Inserisci il tuo messaggio`,
    t203: `Invia`,
    t204: `Letto`,
    t205: `Non letto`,
    t206: `Scadenza limite richiamo`,
    t207: `Annulla`,
    t208: `Foto`,
    t209: `Album`,
    t210: `Fotografare`,
    t211: `Selezionare da Album`,
    t212: `Annulla`,
    t213: `Foto`,
    t214: `Ritratto`,
    t215: `Anteprima`,
    t216: `Completa`,
    t217: `Spazio WeMeet AI`,
    t218: `Contattaci`,
    t219: `Contattami`,
    t220: `Nome completo`,
    t221: `Organizzazione`,
    t222: `Posizione`,
    t223: `Telefono`,
    t224: `E-mail`,
    t225: `Regione`,
    t226: `Zona`,
    t227: `Indirizzo`,
    t228: `Si prega di inserire il tuo nome`,
    t229: `Inserire il nome della vostra organizzazione`,
    t230: `Inserire la vostra posizione`,
    t231: `Si prega di inserire il proprio numero di telefono`,
    t232: `Inserire il vostro indirizzo email`,
    t233: `Si prega di selezionare una regione`,
    t234: `Si prega di selezionare provincia, città e quartiere`,
    t235: `Inserire un indirizzo`,
    t236: `Intenzione`,
    t237: `Acquistare prodotti`,
    t238: `Prodotti agente`,
    t239: `Collaborazione di mercato`,
    t240: `Altro`,
    t241: `Si prega di inserire il tuo nome`,
    t242: `Inserire il nome della vostra organizzazione`,
    t243: `Inserire il vostro indirizzo email`,
    t244: `Il formato dell'e-mail è errato`,
    t245: `Messaggio inviato`,
    t246: `Lasciare un messaggio`,
    t247: `Inserire il contenuto della vostra richiesta`,
    t248: `Confermare`,
    t249: `Per favore effettua prima il login o la registrazione`,
    t250: `Seguaci`,
    t251: `Contattaci`,
    t252: `Prodotti`,
    t253: `Squadra`,
    t254: `Panoramica`,
    t255: `Album`,
    t256: `Qualifica`,
    t257: `Capitale sociale`,
    t258: `Data di fondazione`,
    t259: `Indirizzo registrato`,
    t260: `Alto corso`,
    t261: `Mezzo corso`,
    t262: `Basso corso`,
    t263: `Indústrias associadas`,
    t264: `Procedimento`,
    t265: `Salvare`,
    t266: `Verificato`,
    t267: `Cinese`,
    t268: `Inglese`,
    t269: `Francese`,
    t270: `Russo`,
    t271: `Spagnolo`,
    t272: `Giapponese`,
    t273: `Coreano`,
    t274: `Indonesiano`,
    t275: `Vietnamita`,
    t276: `Tedesco`,
    t277: `Turco`,
    t278: `Italiano`,
    t279: `Portoghese`,
    t280: `Tailandese`,
    t281: `Malese`,
    t282: `Arabo`,
    t283: `Nome utente o password non corretti`,
    t284: `Si prega di leggere e accettare prima l'Accordo Utente di WeMeet`,
    t285: `Non sono presenti contenuti rilevanti`,
    t286: `Tipo`,
    t287: `Attributo`,
    t288: `Dettagli`,
    t289: `Altro`,
    t290: `In totale 2 prodotti`,
    t291: `{1} ti invita a visitare il WeMeet AI Space di {2}`,
    t292: `Clicca qui per un esempio o inserisci una domanda:`,
    t293: `Aggiorna`,
    t294: `Puoi anche fare clic sulla cartolina qui sotto per aggiungere contatti per ulteriori informazioni:`,
    t295: `Imparare`,
    t296: `Riunioni digitali WeMeet`,
    t297: `Mostre digitali WeMeet`,
    t298: `Kişisel kartvizit ve WeMeet AI Alanı`,
    t299: `Come diventare membro di un'organizzazione WeMeet`,
    t300: `WeMeet Servizio di Conferenza Digitale ti fornisce una soluzione completa per riunioni online, che include, ma non si limita a, la creazione e la pubblicazione di riunioni, la gestione delle registrazioni dei partecipanti, il check-in elettronico, la pianificazione delle riunioni, la condivisione dei materiali delle riunioni, le discussioni interattive in tempo reale e le interazioni con gli ospiti.`,
    t301: `WeMeet Fiera Digitale, aiutando a costruire rapidamente un sito web ufficiale micro per mostre. Mostra informazioni sugli espositori, presentazioni dei prodotti esposti, trasmissioni live della fiera, registrazione alla fiera, programma degli eventi e altro ancora, consentendo alle aziende partecipanti e al pubblico di comprendere facilmente i dettagli della fiera. Per utilizzare la funzione WeMeet Fiera Digitale, si prega di completare prima il processo di ingresso istituzionale. Fare clic su "Io", scorrere verso il basso fino a "Centro servizi" - "Ingresso istituzionale" e seguire le indicazioni per completare il processo di ingresso.`,
    t302: `Gli utenti personali di WeMeet devono solo autorizzare il loro ID WeChat, il numero di telefono e completare la registrazione alla piattaforma per ottenere una carta da visita digitale personale e mantenere il proprio Lounge AI personale (che include curriculum personale, aggiornamenti, foto, documenti, ecc.).`,
    t303: `Fare clic sull'opzione "Io" nella barra del menu inferiore del mini-programma per aggiornare la pagina della carta da visita personale e migliorare la home page personale.`,
    t304: `Combinazione di lettere maiuscole e minuscole, numeri e segni di punteggiatura, con una lunghezza compresa tra 8 e 20 caratteri.`,
    t305: `Inserisci il nome del prodotto`,
    t306: `Non ci sono più`,
    t307: `Fare clic sull'angolo in alto a destra`,
    t308: `Scegli il metodo di condivisione preferito`,
    t309: `Ho capito`,
    t310: `Si prega di completare la registrazione e l'accesso prima`,
    t311: `Per saperne di più`,
    t312: `Prodotti correlati`,
    t313: `Grazie per la visita`,
    t314: `Disconnetti`,
    t315: `Organizzazione seguita`,
    t316: `Precedente`,
    t317: `Successivo`,
    t318: `Nessuno`,
    t319: `{1} ti invita a visitare {2}`,
    t320: `AI Lounge non ha mantenuto la lingua corrente`,
    t321: `AI Lounge si è switchato alla lingua corrente`,
    t322: `Il link è stato attivato`,
    t323: `La rete è occupata, si prega di riprovare più tardi`,
    t324: `I dettagli del prodotto sono stati cambiati nella lingua corrente`,
    t325: `I dettagli del prodotto attualmente non sono mantenuti in questa lingua`,
    t326: `Salve, sono l'assistente AI intelligente di WeMeet, pronto a offrirti un servizio premuroso in qualsiasi momento! Come posso aiutarti?`,
    t327: `Inserisci il nome`,
    t328: `Ho trovato le informazioni di contatto pertinenti, controlla la scheda dei contatti qui sotto.`,
    t329: `Allegato`,
    t330: `Non ho trovato le informazioni di contatto pertinenti.`,
    t331: `Ho inoltrato la tua richiesta al collega responsabile qui sotto; puoi anche cliccare sul biglietto da visita per contattare immediatamente.`,
    t332: `Esposizione`,
    t333: `Per favore inserisci`,
    t334: `Utente`,
    t335: `Non ci sono più`,
    t336: `Aggiornamento riuscito`,
    t337: `Caricamento`,
    t338: `Rilasciare per aggiornare`,
  },
};
// 意大利语
